import { render } from "./Client.vue?vue&type=template&id=39951c82&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"

import "./Client.vue?vue&type=style&index=0&id=39951c82&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39951c82"]])

export default __exports__